export default function setOGImageMeta(image_link: string) {
    const og_image = document.querySelector('meta[property="og:image"]')
    if (og_image != null) {
        og_image.setAttribute("content", image_link);
    }
}
